import { useState } from 'react';
import { Table } from 'rsuite';
import { RenderIf } from 'utilities/helpers';
import { ProductCategoryPage } from './category';
import { CustomTable } from 'components/datatable';
import { ProductGroupPage } from './group';
import { ProductItselfPage } from './productitself';
import { useFetchProductsHook } from 'hooks/products/useFetchProductsHook';
import { TextField } from 'components/input';
import styles from './index.module.css';
import {
  useFetchRecipeProductCategories,
  useFetchRecipeProductGroups
} from 'hooks/recipes/useRecipesHook';
import { getBranchId } from 'utilities/helpers/auth';
import { useStore } from 'store';
import { AccessDenied } from 'components/acess-denied';
import { PrimaryButton } from 'components/button';

const { Column, HeaderCell, Cell } = Table;

const ProductCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props}>
    <b>{rowData?.product_name}</b>
  </Cell>
);

const ActionsCell = ({
  setSelectedProduct,
  setAction,
  setAdditionType,
  rowData,
  dataKey,
  onDelete,
  ...props
}) => (
  <Cell {...props}>
    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
      <button
        className="button_sm button_radius"
        style={{
          background: '#a561d8',
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          marginBottom: '10px'
        }}
        onClick={() => {
          setSelectedProduct(rowData?.id);
          setAction('update');
          setAdditionType('product');
        }}
      >
        Edit
      </button>
      {/* <button
        className="button_sm button_radius"
        style={{
          background: '#dc3545',
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px'
        }}
        onClick={() => {
          if (window.confirm('Are you sure you want to delete this product?')) {
            onDelete(rowData?.id);
          }
        }}
      >
        Delete
      </button> */}
    </div>
  </Cell>
);

export const ProductsPage = () => {
  const [action, setAction] = useState('');
  const [additionType, setAdditionType] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { brand, user } = useStore((state) => state);

  const branchId = getBranchId();

  const { productsData, productsLoading } = useFetchProductsHook(
    `products/${brand?.id}/${branchId}`,
    brand?.id,
    branchId
  );

  const {
    data: groupsData,
    isLoading: groupLoading,
    refetch: refetchGroups
  } = useFetchRecipeProductGroups(branchId);

  const {
    data: categoriesData,
    isLoading: categoryLoading,
    refetch: refetchCategories
  } = useFetchRecipeProductCategories(branchId);

  const [searchField, setSearchField] = useState('');

  const handleDeleteProduct = async (productId) => {
    try {
      // Here you would typically call your delete API
      // For now, we'll just show a console log
      console.log('Deleting product with ID:', productId);

      // Example API call (uncomment and modify as needed):
      // await deleteProduct(productId);
      // refetch products data

      alert('Product deleted successfully!');
    } catch (error) {
      console.error('Error deleting product:', error);
      alert('Failed to delete product. Please try again.');
    }
  };

  const filteredProductData = productsData?.filter((product) => {
    return (
      product?.product_name
        ?.toLowerCase()
        ?.includes(searchField?.toLowerCase()) ||
      product?.unit?.toLowerCase()?.includes(searchField?.toLowerCase()) ||
      product?.upc?.toLowerCase()?.includes(searchField?.toLowerCase())
    );
  });

  const productPermission = user?.role?.permissions?.find(
    (permission) =>
      permission?.module_slug === 'products' &&
      permission?.slug === 'inventory_management'
  );

  return (
    <>
      <RenderIf isTrue={!productPermission?.access?.read}>
        <AccessDenied />
      </RenderIf>

      <RenderIf isTrue={productPermission?.access?.read}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <h2
            style={{
              fontSize: '24px',
              fontWeight: '800',
              margin: '20px 0px'
            }}
          >
            Products
          </h2>
          <PrimaryButton onClick={() => setAdditionType('product')}>
            Add Product
          </PrimaryButton>
        </div>
        <div className={styles.pt_32}></div>
        {/* <div className="add_new_grid">
          <AddCards
            name="fileChecked"
            heading="Add Category"
            description="Easily expand your product catalog by creating new categories."
            onClick={() => setAdditionType('category')}
            disabled={!productPermission?.access?.create}
          />
          <AddCards
            name="fileScratch"
            heading="Add Group"
            description="Group related products together to enhance organization and simplify management."
            onClick={() => setAdditionType('group')}
            disabled={!productPermission?.access?.create}
          />
          <AddCards
            name="fileScratch"
            heading={
              !groupLoading &&
              !categoryLoading &&
              (groupsData?.length === 0 || categoriesData?.length === 0)
                ? 'Add Product (Disabled)'
                : 'Add/Update Product Inventory'
            }
            description={
              categoriesData?.length === 0 && groupsData?.length === 0
                ? 'Please add atleast one product category and one product group'
                : categoriesData?.length === 0
                ? 'Please add atleast one product category'
                : groupsData?.length === 0
                ? 'Please add atleast one product group'
                : 'Expand your inventory by adding a new product.'
            }
            onClick={() => setAdditionType('product')}
            disabled={
              (!groupLoading &&
                !categoryLoading &&
                (groupsData?.length === 0 || categoriesData?.length === 0)) ||
              productPermission?.access?.create === false
            }
          />
        </div> */}
        <div>
          <RenderIf isTrue={additionType === 'category'}>
            <ProductCategoryPage
              action={action}
              setAction={setAction}
              setAdditionType={setAdditionType}
              refetchGroups={refetchGroups}
              refetchCategories={refetchCategories}
            />
          </RenderIf>
          <RenderIf isTrue={additionType === 'group'}>
            <ProductGroupPage
              action={action}
              setAction={setAction}
              setAdditionType={setAdditionType}
              refetchGroups={refetchGroups}
              refetchCategories={refetchCategories}
            />
          </RenderIf>
          <RenderIf isTrue={additionType === 'product'}>
            <ProductItselfPage
              action={action}
              setAction={setAction}
              setAdditionType={setAdditionType}
              selectedProduct={selectedProduct}
              setSelectedProduct={setSelectedProduct}
            />
          </RenderIf>
        </div>
        <div>
          {/* <div style={{ marginTop: 10 }}></div>
          <h4>
            <span className="ff_semi">Products</span>
          </h4> */}
          <div style={{ marginTop: 24 }}></div>
          <div className="box2 flex item_vcenter item_space_btn">
            <div className="w_356">
              <TextField
                onChange={(e) => setSearchField(e?.target?.value)}
                value={searchField}
                placeholder={'Type and see result'}
              />
            </div>
            <div></div>
          </div>
          <div style={{ marginTop: 24 }}></div>
          {/* <div className={styles.search_grid}>
          <div>
            <input
              className={`text_field`}
              type={`text`}
              name={`search`}
              placeholder={`Type and see result`}
              onChange={handleChange}
            />
          </div>
          <div></div>
        </div> */}
          <RenderIf isTrue={filteredProductData?.length === 0}>
            <div className={`no_data1`}>No data found.</div>
          </RenderIf>
          <RenderIf isTrue={filteredProductData?.length > 0}>
            <CustomTable
              rows={filteredProductData?.map((product, index) => {
                return {
                  id: product?.id || index + 1, // Use actual product ID for actions
                  display_id: index + 1, // Display ID for the table
                  product_name: product?.product_name || '-',
                  product_category:
                    product?.product_category?.category_name || '-',
                  product_group: product?.product_group?.group_name || '-',
                  // unit: product?.unit || '-',
                  upc: product?.upc || '-',
                  current_unit_price: product?.current_unit_price || '-'
                  // added_at: product?.created_at?.split('T')?.[0] || '-'
                };
              })}
              loading={productsLoading}
              pageLimit={10}
              pagination={filteredProductData?.length > 10 ? true : false}
            >
              <Column width={50} align="center" fixed>
                <HeaderCell>Id</HeaderCell>
                <Cell dataKey="display_id" />
              </Column>
              <Column flexGrow={1} sortable>
                <HeaderCell>Product Name</HeaderCell>
                <ProductCell dataKey="product_name" />
              </Column>
              <Column width={220} sortable>
                <HeaderCell>Product Category</HeaderCell>
                <Cell dataKey="product_category" />
              </Column>
              <Column width={220} sortable>
                <HeaderCell>Product Group</HeaderCell>
                <Cell dataKey="product_group" />
              </Column>
              {/* <Column width={220} sortable>
                <HeaderCell>Unit</HeaderCell>
                <Cell dataKey="unit" />
              </Column> */}
              <Column width={200} sortable>
                <HeaderCell>Upc</HeaderCell>
                <Cell dataKey="upc" />
              </Column>
              <Column width={150} fixed="right">
                <HeaderCell>Actions</HeaderCell>
                <ActionsCell
                  setSelectedProduct={setSelectedProduct}
                  setAction={setAction}
                  setAdditionType={setAdditionType}
                  onDelete={handleDeleteProduct}
                />
              </Column>
            </CustomTable>
          </RenderIf>
          {/* <DataTableComponent
          columns={[
            {
              title: 'id',
              dataKey: 'id'
            },
            {
              title: 'Product Name',
              dataKey: 'product_name',
              sortable: true
            },
            {
              title: 'Unit',
              dataKey: 'unit',
              sortable: true
            },
            {
              title: 'Upc',
              dataKey: 'upc',
              sortable: true
            },
            {
              title: 'Current Unit Price',
              dataKey: 'current_unit_price',
              sortable: true
            },
            {
              title: 'Average Unit Price',
              dataKey: 'average_unit_price',
              sortable: true
            }
            {
              title: 'Actions',
              dataKey: 'actions',
              actionHandler: (row) => {
                setSelectedProduct(row?.id);
                setAction('update');
                setAdditionType('product');
              }
            }
          ]}
          rows={productsData?.map((product, index) => {
            return {
              id: index + 1,
              product_name: product?.product_name || '-',
              unit: product?.unit || '-',
              upc: product?.upc || '-',
              current_unit_price: product?.current_unit_price || '-',
              average_unit_price: product?.average_unit_price || '-'
            };
          })}
          loading={productsLoading}
          pageLimit={10}
        /> */}
        </div>
        <div className="mt_40"></div>
      </RenderIf>
    </>
  );
};
